import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { url: String }

  submit(e) {
    e.preventDefault()
    const btn = this.buttonTarget

    // Show loading state
    this.originalHTML = btn.innerHTML
    btn.classList.add("opacity-50", "pointer-events-none")
    btn.innerHTML = `<svg class="w-4 h-4 animate-spin shrink-0" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
    </svg><span>Syncing...</span>`

    // XHR POST — no navigation, broadcasts handle the UI update
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "application/json"
      }
    }).then(res => res.json())
      .then(() => {
        // Reset button after short delay (broadcasts arrive async)
        setTimeout(() => this.resetButton(), 3000)
      })
      .catch(err => {
        console.error("[form-loading] error:", err)
        this.resetButton()
      })
  }

  resetButton() {
    const btn = this.buttonTarget
    btn.classList.remove("opacity-50", "pointer-events-none")
    btn.innerHTML = this.originalHTML
  }
}
